import React from 'react';
import { cn } from './cn';

// Dual-ring spinner (a spinner spinning is fine; the linear-motion ban is about state changes).
export function Spinner({ className, size = 28 }) {
    return (
        <span
            className={cn('inline-block animate-spin rounded-full border-2 border-espresso/15 border-t-espresso/70', className)}
            style={{ width: size, height: size }}
            role="status"
            aria-label="Đang tải"
        />
    );
}

export function LoadingScreen({ label = 'Đang tải…' }) {
    return (
        <div className="flex min-h-[40vh] flex-col items-center justify-center gap-4 text-espresso-soft">
            <Spinner />
            <span className="text-sm">{label}</span>
        </div>
    );
}

export function EmptyState({ icon: Icon, title, description, action, className }) {
    return (
        <div className={cn('flex flex-col items-center justify-center gap-3 px-6 py-16 text-center', className)}>
            {Icon && (
                <span className="flex h-14 w-14 items-center justify-center rounded-full bg-espresso/[0.05] text-espresso-soft">
                    <Icon size={26} weight="light" />
                </span>
            )}
            <h3 className="font-serif text-xl text-espresso">{title}</h3>
            {description && <p className="max-w-sm text-sm text-espresso-soft/80">{description}</p>}
            {action && <div className="mt-2">{action}</div>}
        </div>
    );
}
